import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Text, Button, Icon } from '@vmos2/design-system';

type Props = {
  isOpen: boolean,
  onClose: Function,
  onSubmit: Function,
}
export const DeleteAddressModal = ({ isOpen, onClose, onSubmit }: Props) => {
  const [isPending, setPending] = useState(false);
  const { t } = useTranslation('profile.settings');

  const handleOnSubmit = async (props) => {
    setPending(true);
    await onSubmit(props);
    setPending(false);
  };

  return (
    <Modal
      size="small"
      isOpen={isOpen}
      title={t('deleteAddress')}
      onRequestClose={onClose}
      footerLeftSide={<Button block contentCenter mode="light" onClick={onClose}>{t('common:no')}</Button>}
      footerRightSide={
      <Button
        block
        contentCenter
        onClick={handleOnSubmit}
        disabled={isPending}
        data-test="delete-address-button"
      >{isPending ? <Icon name="Spinner" spin /> : t('common:yes')}</Button>}
    >
      <Text>{t('deleteAddressDescription')}</Text>
    </Modal>
  );
};
